module.exports = __webpack_public_path__ + "media/dashboard/assets/images/profile_notification-362fbd39aa3d2c726e5c0b79c67944b9.svg";